import initFormsSubmit from "../components/initFormsSubmit.js";
import initModals from "../components/initModals.js";
import initHelpers from "../components/initHelpers.js";
import initSliders from "../components/initSliders.js";

document.addEventListener("DOMContentLoaded", () => {

    console.log("article-item.js")

    initFormsSubmit();
    initModals();

    const { initCopyLink, makeTablesResponsive } = initHelpers();
    initCopyLink();
    makeTablesResponsive();

    const {
        initArticlesSlider,
    } = initSliders();

    initArticlesSlider();

});
